import React, { useState, useEffect, useContext } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import DeleteIcon from "@mui/icons-material/Delete";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import {
  StyledTableCell,
  StyledTableRow,
} from "components/atoms/table/StyledTable";
import Pagination from "components/atoms/table/Pagination";

import { SnackContext } from "context/SnackProvider";
import instance, { getErrorMessage } from "api/definitions";
import MessageDialog, {
  MessageDialogVariants,
} from "components/atoms/info/MessageDialog";

const DeleteLocationPermission = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setIsLoaded(false);
    if (props.loadDelete) {
      const fullURLDelete = `local/${props.idLocation}/permissao/user/${props.idPermission}`;

      instance
        .delete(fullURLDelete)
        .then(function (response) {
          setIsLoaded(true);
          const result = response.data;
          if (result) {
            snackContext.setMessage(
              `Permissão removida deste Local com sucesso`,
              "success"
            );
            props.handleClose();
          }
        })
        .catch(function (error) {
          setIsLoaded(true);
          const msg = getErrorMessage(error);
          snackContext.setMessage(msg, "error");
        });
    }
  }, [props, snackContext]);

  if (props.loadDelete && !isLoaded) return <CircularProgress />;
};

const ParticipantsTable = (props) => {
  const [loadDelete, setLoadDelete] = useState(false);
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false);
  const [idPermission, setIdPermission] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const rows = props.rows;
  const rowsLength = rows.length;

  const pageCallback = (childData) => {
    setPage(childData);
  };

  const rowsPerPageCallback = (childData) => {
    setRowsPerPage(childData);
  };

  ///Delete
  const handleClickDelete = (event) => {
    setIdPermission(event.currentTarget.id);
    setOpenDeleteConfirmDialog(true);
  };
  const handleCloseDeleteDialog = (event) => {
    setOpenDeleteConfirmDialog(false);
  };
  const handleConfirmDelete = (event) => {
    setOpenDeleteConfirmDialog(false);
    setLoadDelete(true);
  };
  const handleBack = () => {
    setLoadDelete(false);
    props.handleReloadTable();
  };

  if (rowsLength === 0) {
    return (
      <Typography sx={{ color: "error.main" }}>
        Este local não tem permissões.
      </Typography>
    );
  } else {
    const cells = (
      rowsPerPage > 0
        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : rows
    ).map((row, index) => {
      return (
        <StyledTableRow key={row.id}>
          <StyledTableCell>
            {row.grupo === "0" ? "CPF" : "Grupo"}
          </StyledTableCell>
          <StyledTableCell>{row.identificador}</StyledTableCell>
          <StyledTableCell>
            <IconButton
              onClick={handleClickDelete}
              id={row.id}
              sx={{
                bgcolor: "",
                "&:hover": {
                  backgroundColor: "error.light",
                },
              }}
            >
              <DeleteIcon />
            </IconButton>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
    return (
      <Box sx={{ mb: 2 }}>
        <TableContainer>
          <Table aria-label="data table" size="small">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Tipo</StyledTableCell>
                <StyledTableCell>Identificador</StyledTableCell>
                <StyledTableCell sx={{ width: 10 }}>Excluir</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>{cells}</TableBody>
          </Table>
        </TableContainer>
        <Pagination
          name="Permissões"
          length={rows.length}
          pageParentToChild={page}
          rowsPerPageParentToChild={rowsPerPage}
          pageCallback={pageCallback}
          rowsPerPageCallback={rowsPerPageCallback}
        />
        <Box id="boxDelete">
          <DeleteLocationPermission
            loadDelete={loadDelete}
            idLocation={props.idLocation}
            idPermission={idPermission}
            handleClose={handleBack}
          />
          <MessageDialog
            confirm
            variant={MessageDialogVariants.error}
            title="Exclusão"
            open={openDeleteConfirmDialog}
            onClose={handleCloseDeleteDialog}
            onConfirm={handleConfirmDelete}
          >
            Você tem certeza que gostaria de excluir esta permissão?
          </MessageDialog>
        </Box>
      </Box>
    );
  }
};

const LocationPermissionTable = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const [reloadTable, setReloadTable] = useState(false);

  const snackContext = useContext(SnackContext);

  const handleReloadTable = (event) => {
    setReloadTable(!reloadTable);
  };

  useEffect(() => {
    const fullURL = `local/${props.idLocation}/permissao`;

    instance
      .get(fullURL)
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        const vin = result.vinculos;
        const users = result.users;
        const groups = result.groups;
        const array2 = vin.concat(users);
        const newResult = array2.concat(groups);

        setItems(newResult);
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        snackContext.setMessage(msg, "error");
      });
  }, [props.idLocation, props.reloadTable, reloadTable, snackContext]);

  if (!isLoaded) return <CircularProgress />;
  else
    return (
      <ParticipantsTable
        idLocation={props.idLocation}
        rows={items}
        handleReloadTable={handleReloadTable}
      />
    );
};

export default LocationPermissionTable;
